import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/account/orders/$orderId")({
  head: () => ({ meta: [{ title: "Order Details | BAZZAR 3D" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/account-orders-orderId")),
});
